<template>
  <div id="app">
    <Loading :active.sync="loading"></Loading>
   
    <NavigationLogged v-if="isLogged"/>
    <NavigationGuest v-else/>
    <router-view/>
  </div>
</template>
<script>
  import NavigationLogged from '@/components/navigations/Logged'
  import NavigationGuest from '@/components/navigations/Guest'
  import {mapState} from 'vuex'
  import Loading from 'vue-loading-overlay'
  import 'vue-loading-overlay/dist/vue-loading.css'

  export default{
    components:{
      NavigationLogged, NavigationGuest , Loading
    },
    computed:{
      ...mapState ('login',['isLogged']),
      ...mapState (['loading']),
    }
  }
</script>
<style lang="scss">


</style>
